<div class="dropdown-header text-center"><strong>Account</strong></div>
<button *ngIf="environment.cordova" class="dropdown-item" (click)="onSyncAPI()"><i class="fa fa-refresh"></i> Sync resources</button>
<button class="dropdown-item" (click)="onLogout()"><i class="fa fa-lock"></i> Logout</button>
